module.exports = __webpack_public_path__ + "e5c8c2854ee0953fb9c448012b7d7a25.svg";